import React from 'react'

import { Button } from '../@primitives/button'

import styled, { css } from 'react-emotion'

const SideBySideStyles = styled('div')`
  &:not(:last-of-type) {
    margin-bottom: 100px;
  }
`

const Grid = styled('div')`
  max-width: ${props => props.narrow ? 80 : 100}%;
  margin: auto;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 30px;
  direction: ${props => props.align === 'right' ? 'rtl' : 'ltr'};

  div { text-align: left; }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    max-width: 100%;
  }
  
  a {
    margin-top: 10px;
  }
`

export const SideBySide = (props) =>
  <SideBySideStyles>
    <Grid align={props.align} narrow={props.narrow}>
      <div>
        <div
          className={css`
            background-image: url('${props.image}');
            background-repeat: no-repeat;
            background-position: center;
            background-size: ${props.contain ? 'contain' : 'cover'};
            border-radius: 4px;
            overflow: hidden;
            padding-top: 67%;
          `}
        />
      </div>
      <div className={css`direction: ltr;`}>
        <h2>{props.heading}</h2>
        {props.copy &&
          <p>
            {props.copy}
          </p>
        }
        {props.html &&
          <div dangerouslySetInnerHTML={{ __html: props.html }} />
        }
        {props.to &&
          <Button to={props.to}>{props.text}</Button>
        }
        {props.downloads &&
          props.downloads.map((download, i) => (
            <Button external to={download.file} key={i}>{download.text || 'Download PDF'}</Button>
          ))
        }
      </div>
    </Grid>
  </SideBySideStyles>


// WEBPACK FOOTER //
// ./src/components/SideBySide/index.js